export const lastRouters = [
  {
    path: '*',
    redirect: '/dashboard',
    meta: {},
    hidden: true
  }
]
